import { render } from "./DashboardSelection.vue?vue&type=template&id=0e01f3db&scoped=true"
import script from "./DashboardSelection.vue?vue&type=script&lang=js"
export * from "./DashboardSelection.vue?vue&type=script&lang=js"

import "./DashboardSelection.vue?vue&type=style&index=0&id=0e01f3db&scoped=true&lang=css"

import exportComponent from "/src/clientapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e01f3db"]])

export default __exports__